import css from './Mobile.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { Breakpoints } from 'meta/layout/breakpoints'
import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_MEDIUMGREY } from 'utils/constants/colors'

import { Grid, GridColumn, GridContainer } from 'components/Layout/Grid'

import PaginatorSkeleton from '../PaginatorSkeleton/PaginatorSkeleton'

const Mobile: React.FC = () => {
  return (
    <>
      <div className={css.checkout_season_items_skeleton_mobile_container}>
        {[1, 2, 3, 4].map((_elem, key) => (
          <GridContainer key={key}>
            <Grid>
              <GridColumn gridColumnStart={{ [Breakpoints.mobile]: 1 }} gridColumnEnd={{ [Breakpoints.mobile]: 17 }}>
                <Skeleton
                  className={css.itemSkeleton}
                  baseColor={TICKETSMS_COLORS_MEDIUMGREY}
                  borderRadius={16}
                  highlightColor={TICKETSMS_COLORS_LIGHTGREY}
                />
              </GridColumn>
            </Grid>
          </GridContainer>
        ))}
      </div>

      <PaginatorSkeleton />
    </>
  )
}

export default Mobile
